/* eslint-enable */
// Some icons have abbreviated names due to
// the limitations on the number of characters in imports.
// Therefore, some words are
// abbreviated to C - circle, S - square, T - triangle.
// For example, here ARROW_LEFT_C, C stands for circle.
/* eslint-enable */

import { ReactComponent as TwoUser } from './svg-icons/2User.svg';
import { ReactComponent as ThreeUser } from './svg-icons/3User.svg';
import { ReactComponent as AddUser } from './svg-icons/AddUser.svg';
import { ReactComponent as ArrowDown } from './svg-icons/ArrowDown.svg';
import { ReactComponent as ArrowDown2 } from './svg-icons/ArrowDown2.svg';
import { ReactComponent as ArrowDownC } from './svg-icons/ArrowDownC.svg';
import { ReactComponent as ArrowDownS } from './svg-icons/ArrowDownS.svg';
import { ReactComponent as ArrowLeft } from './svg-icons/ArrowLeft.svg';
import { ReactComponent as ArrowLeft2 } from './svg-icons/ArrowLeft2.svg';
import { ReactComponent as ArrowLeftC } from './svg-icons/ArrowLeftC.svg';
import { ReactComponent as ArrowLeftS } from './svg-icons/ArrowLeftS.svg';
import { ReactComponent as ArrowRight } from './svg-icons/ArrowRight.svg';
import { ReactComponent as ArrowRight2 } from './svg-icons/ArrowRight2.svg';
import { ReactComponent as ArrowRightC } from './svg-icons/ArrowRightC.svg';
import { ReactComponent as ArrowRightS } from './svg-icons/ArrowRightS.svg';
import { ReactComponent as ArrowUp } from './svg-icons/ArrowUp.svg';
import { ReactComponent as ArrowUp2 } from './svg-icons/ArrowUp2.svg';
import { ReactComponent as ArrowUpC } from './svg-icons/ArrowUpC.svg';
import { ReactComponent as ArrowUpS } from './svg-icons/ArrowUpS.svg';
import { ReactComponent as BanNotific } from './svg-icons/BanNotific.svg';
import { ReactComponent as Category } from './svg-icons/Category.svg';
import { ReactComponent as Chat } from './svg-icons/Chat.svg';
import { ReactComponent as DangerCircle } from './svg-icons/DangerCircle.svg';
import { ReactComponent as DangerT } from './svg-icons/DangerT.svg';
import { ReactComponent as Delete } from './svg-icons/Delete.svg';
import { ReactComponent as Document } from './svg-icons/Document.svg';
import { ReactComponent as Download } from './svg-icons/Download.svg';
import { ReactComponent as Edit } from './svg-icons/Edit.svg';
import { ReactComponent as EditSquare } from './svg-icons/EditSquare.svg';
import { ReactComponent as ErrorIcon } from './svg-icons/InputError.svg';
import { ReactComponent as Filter } from './svg-icons/Filter.svg';
import { ReactComponent as Filter3 } from './svg-icons/Filter3.svg';
import { ReactComponent as Heart } from './svg-icons/Heart.svg';
import { ReactComponent as HeartBlue } from './svg-icons/HeartBlue.svg';
import { ReactComponent as HeartRed } from './svg-icons/HeartRed.svg';
import { ReactComponent as Hide } from './svg-icons/Hide.svg';
import { ReactComponent as Home } from './svg-icons/Home.svg';
import { ReactComponent as Image } from './svg-icons/Image.svg';
import { ReactComponent as Image3 } from './svg-icons/Image3.svg';
import { ReactComponent as InfoSquare } from './svg-icons/InfoSquare.svg';
import { ReactComponent as Lock } from './svg-icons/Lock.svg';
import { ReactComponent as Login } from './svg-icons/Login.svg';
import { ReactComponent as Logout } from './svg-icons/Logout.svg';
import { ReactComponent as Message } from './svg-icons/Message.svg';
import { ReactComponent as MoreCircle } from './svg-icons/MoreCircle.svg';
import { ReactComponent as MoreSquare } from './svg-icons/MoreSquare.svg';
import { ReactComponent as NoActivity } from './svg-icons/NoActivity.svg';
import { ReactComponent as Notification } from './svg-icons/Notification.svg';
import { ReactComponent as Plus } from './svg-icons/Plus.svg';
import { ReactComponent as Profile } from './svg-icons/Profile.svg';
import { ReactComponent as PropertyAct } from './svg-icons/PropertyAct.svg';
import { ReactComponent as Read } from './svg-icons/read.svg';
import { ReactComponent as Search } from './svg-icons/Search.svg';
import { ReactComponent as Send } from './svg-icons/Send.svg';
import { ReactComponent as Setting } from './svg-icons/Setting.svg';
import { ReactComponent as ShieldDone } from './svg-icons/ShieldDone.svg';
import { ReactComponent as ShieldFail } from './svg-icons/ShieldFail.svg';
import { ReactComponent as Show } from './svg-icons/Show.svg';
// import { ReactComponent as Smile } from './svg-icons/Smile.svg'; //! CHAT-220--smile-disable
import { ReactComponent as Star } from './svg-icons/Star.svg';
import { ReactComponent as Subscribe } from './svg-icons/Subscribe.svg';
import { ReactComponent as Swap } from './svg-icons/Swap.svg';
import { ReactComponent as TickSquare } from './svg-icons/TickSquare.svg';
import { ReactComponent as TimeCircle } from './svg-icons/TimeCircle.svg';
import { ReactComponent as TimeSquare } from './svg-icons/TimeSquare.svg';
import { ReactComponent as Unlock } from './svg-icons/Unlock.svg';
import { ReactComponent as Unread } from './svg-icons/unread.svg';
import { ReactComponent as Upload } from './svg-icons/Upload.svg';
import { ReactComponent as VolumeDown } from './svg-icons/VolumeDown.svg';
import { ReactComponent as VolumeOff } from './svg-icons/VolumeOff.svg';
import { ReactComponent as VolumeUp } from './svg-icons/VolumeUp.svg';
import { ReactComponent as Logo } from './logo/Logo.svg';
import { ReactComponent as Confirm } from './svg-icons/Confirm.svg';
import { ReactComponent as Close } from './svg-icons/CloseSquare.svg';
import { ReactComponent as Cross } from './svg-icons/Cross.svg';

export const ICONS = {
  TWO_USER: TwoUser,
  THREE_USER: ThreeUser,
  ADD_USER: AddUser,
  ARROW_DOWN: ArrowDown,
  ARROW_DOWN2: ArrowDown2,
  ARROW_DOWN_C: ArrowDownC,
  ARROW_DOWN_S: ArrowDownS,
  ARROW_LEFT: ArrowLeft,
  ARROW_LEFT2: ArrowLeft2,
  ARROW_LEFT_C: ArrowLeftC,
  ARROW_LEFT_S: ArrowLeftS,
  ARROW_RIGHT: ArrowRight,
  ARROW_RIGHT2: ArrowRight2,
  ARROW_RIGHT_C: ArrowRightC,
  ARROW_RIGHT_S: ArrowRightS,
  ARROW_UP: ArrowUp,
  ARROW_UP2: ArrowUp2,
  ARROW_UP_C: ArrowUpC,
  ARROW_UP_S: ArrowUpS,
  BAN_NOTIFICATION: BanNotific,
  CATEGORY: Category,
  CONFIRM: Confirm,
  CHAT: Chat,
  CLOSE_SQUARE: Close,
  CROSS: Cross,
  DANGER_CIRCLE: DangerCircle,
  DANGER_TRIANGLE: DangerT,
  DELETE: Delete,
  DOCUMENT: Document,
  DOWNLOAD: Download,
  EDIT: Edit,
  EDIT_SQUARE: EditSquare,
  ERROR: ErrorIcon,
  FILTER: Filter,
  FILTER3: Filter3,
  HEART: Heart,
  HEART_BLUE: HeartBlue,
  HEART_RED: HeartRed,
  HIDE: Hide,
  HOME: Home,
  IMAGE: Image,
  IMAGE3: Image3,
  INFO_SQUARE: InfoSquare,
  LOCK: Lock,
  LOGIN: Login,
  LOGO: Logo,
  LOGOUT: Logout,
  MESSAGE: Message,
  MORE_CIRCLE: MoreCircle,
  MORE_SQUARE: MoreSquare,
  NO_ACTIVITY: NoActivity,
  NOTIFICATION: Notification,
  PLUS: Plus,
  PROFILE: Profile,
  PROPERTY_ACTIVITY: PropertyAct,
  READ: Read,
  SEARCH: Search,
  SEND: Send,
  SETTING: Setting,
  SHIELD_DONE: ShieldDone,
  SHIELD_FAIL: ShieldFail,
  SHOW: Show,
  // SMILE: Smile, //! CHAT-220--smile-disable
  STAR: Star,
  SUBSCRIBE: Subscribe,
  SWAP: Swap,
  TICK_SQUARE: TickSquare,
  TIME_CIRCLE: TimeCircle,
  TIME_SQUARE: TimeSquare,
  UNLOCK: Unlock,
  UNREAD: Unread,
  UPLOAD: Upload,
  VOLUME_DOWN: VolumeDown,
  VOLUME_OFF: VolumeOff,
  VOLUME_UP: VolumeUp,
};
